import React, { Component } from 'react';

import Button from '../shared/Button';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import {
  showExitModal,
  acceptExitRegulation,
  updateSelectedSeat,
  showUpsellModal,
  acceptSeat,
  confirmBasket,
} from '../../redux/actions';
import SeatDisclaimerModal from './SeatDisclaimerModal';
import { isMobile } from 'react-device-detect';
import MediaQuery from 'react-responsive';
import { rtlLangs } from '../../translations/rtl-langs';

class ExitRegulations extends Component {
  makeModalTitle() {
    return (
      <FormattedMessage
        id="exit_regulations_modal_title"
        defaultMessage="For safety reasons to sit in an emergency exit seat you must:"
      />
    );
  }

  makeTitle() {
    return (
      <FormattedMessage
        id="exit_regulations_title"
        defaultMessage="Emergency exit seat requirements"
      />
    );
  }

  makeBulletPoints() {
    const reasons = [
      <FormattedMessage
        id="exit_regulations_reason_1"
        defaultMessage="Be at least 16 years old"
        key="reason-1"
      />,
      <FormattedMessage
        id="exit_regulations_reason_2"
        defaultMessage="Be willing and able to help in the event of an emergency"
        key="reason-2"
      />,
      <FormattedMessage
        id="exit_regulations_reason_3"
        defaultMessage="Not be traveling with an infant"
        key="reason-3"
      />,
      <FormattedMessage
        id="exit_regulations_reason_4"
        defaultMessage="Not require a seat belt extender"
        key="reason-4"
      />,
      <FormattedMessage
        id="exit_regulations_reason_5"
        defaultMessage="Not have booked an extra seat (comfort or additional item)"
        key="reason-5"
      />,
      <FormattedMessage
        id="exit_regulations_reason_6"
        defaultMessage="Not require airport special assistance of any kind"
        key="reason-6"
      />,
    ];

    return (
      <ul
        className="gr-exit-regulations gr-list-inside gr-mb-8"
        style={{ listStyle: 'circle' }}
      >
        {reasons.map((reason, index) => (
          <li key={index} className="gr-exit-regulations gr-mb-2">
            {reason}
          </li>
        ))}
      </ul>
    );
  }

  makeConfirmIntentText() {
    return (
      <FormattedMessage
        id="exit_regulations_criteria"
        defaultMessage="Do you accept the exit seat criteria?"
      />
    );
  }

  makeAcceptButton() {
    const {
      variants,
      selectedSeat,
      currentSeatmap,
      currentPassenger,
      acceptSeat,
      acceptExitRegulation,
      relativeWidthRatio,
      selectedProduct,
      confirmBasket,
    } = this.props;
    const {
      test_seatmap_one_click_desktop = true,
      test_seatmap_one_click_mobile = false,
      test_confirm_on_click = false,
    } = variants;
    const seat = selectedSeat;
    return (
      <MediaQuery maxWidth={620 / relativeWidthRatio}>
        {(isMobileSize) => (
          <Button
            handleClick={() => {
              acceptExitRegulation(true);
              const isMobileLike = isMobile || isMobileSize;
              const test_seatmap_one_click = isMobileLike
                ? test_seatmap_one_click_mobile
                : test_seatmap_one_click_desktop;
              if (test_seatmap_one_click) {
                acceptSeat({
                  currentSeatmap: currentSeatmap,
                  selectedSeat: seat,
                  currentPassenger: currentPassenger,
                  selectedProduct: selectedProduct,
                });
              }
              this.props.showExitModal(false);
              test_confirm_on_click && confirmBasket(); // Confirm basket if Otravo embedded version
            }}
            id="accept_exit_regulations"
            primary
          >
            <FormattedMessage
              id="exit_regulations_accept"
              defaultMessage="Accept"
            />
          </Button>
        )}
      </MediaQuery>
    );
  }

  makeDeclineButton() {
    return (
      <Button
        handleClick={() => {
          this.props.showExitModal(false);
          this.props.updateSelectedSeat(null);
          // If the upsell is currently showing, and a user declines the exit regulations, close the upsell window too.
          if (this.props.upsellModal) {
            this.props.showUpsellModal(false);
          }
        }}
        id="decline_exit_regulations"
      >
        <FormattedMessage
          id="exit_regulations_decline"
          defaultMessage="Decline"
        />
      </Button>
    );
  }

  render() {
    return (
      <SeatDisclaimerModal
        name={'exit-regulations'}
        modalTitle={this.makeModalTitle()}
        title={this.makeTitle()}
        bulletPoints={this.makeBulletPoints()}
        confirmIntentText={this.makeConfirmIntentText()}
        acceptButton={this.makeAcceptButton()}
        declineButton={this.makeDeclineButton()}
        direction={rtlLangs.includes(this.props.locale) ? 'rtl' : 'ltr'}
        showThisModal={this.props.showExitModal}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  upsellModal: state.session.upsellModal,
  currentPassenger: state.passengers.currentPassenger,
  currentSeatmap: state.itinerary.currentSeatmap,
  selectedSeat: state.selectedSeat,
  variants: state.session.variants,
  relativeWidthRatio: state.session.relativeWidthRatio,
  selectedProduct:
    state.products.products?.seat?.[state.selectedSeat?.product_id] || null,
  locale: state.session.locale,
});

const mapDispatchToProps = {
  showExitModal,
  acceptExitRegulation,
  updateSelectedSeat,
  showUpsellModal,
  acceptSeat,
  confirmBasket,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExitRegulations);
